import { render, staticRenderFns } from "./DeskEdit.vue?vue&type=template&id=0cc44d0b&scoped=true"
import script from "./DeskEdit.vue?vue&type=script&lang=js"
export * from "./DeskEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc44d0b",
  null
  
)

export default component.exports